module.exports = __webpack_public_path__ + "static/step4-dfe150942d9c89ad7b5c796de2ff7a96.png";